<template>
  <div
    v-if="isBarVisible"
    class="vehicle-bar"
    :class="{
      'bg-light': !hasCampaigns,
      'bg-warning': hasCampaigns,
    }"
  >
    <div class="container-fluid">
      <div class="row wrap">
        <div class="col-xs-12">
          <div class="row middle-sm selected-vehicle-bar">
            <div class="col-xs-12">
              <SfIcon
                v-if="hasCampaigns"
                class="info-icon"
                :title="$t('Technical Campaigns')"
                icon="info_circle"
                size="16px"
              />
              <img :src="carIcon" size="sm" class="car-icon" />
              {{ " " }}
              <router-link to="/level4"
                ><b>{{ vehicleData.Vin }}</b></router-link
              >
              {{ " " }}
              <div class="font-wrapper">
                <span>{{ vehicleData.VehicleInfo.marke }} </span>
                <span>{{ vehicleData.VehicleInfo.baureihe }} </span>
                <span>{{ vehicleData.VehicleInfo.verkaufsbezeichnung }} </span>
                <span>{{ vehicleData.VehicleInfo.motor }} </span>
                <span>{{ vehicleData.VehicleInfo.produktionsdatum }} </span>
                <span>{{ $t("Paint") }}: {{ vehicleData.VehicleData.lackCode }} </span>
                <span>{{ $t("Pad") }}: {{ vehicleData.VehicleData.polsterCode }} </span>
              </div>
              <SfButton
                class="sf-button--text button-mod"
                @click="vehicleModalVisible = true"
                :aria-label="$t('Details')"
              >
                {{ $t("Details") }}
              </SfButton>
              {{ " " }}
              <SfButton
                class="sf-button--text button-mod"
                @click="onReset"
                :aria-label="$t('Reset')"
              >
                {{ $t("Reset") }}
              </SfButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VehicleModal :visible="vehicleModalVisible" @close="vehicleModalVisible = false" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SfIcon, SfButton } from '@storefront-ui/vue';

import carIcon from '../../assets/car.svg';
import VehicleModal from '../modals/VehicleModal.vue';

export default {
  name: 'SelectedVehicleBar',
  components: {
    SfButton,
    SfIcon,
    VehicleModal,
  },
  data() {
    return {
      vehicleModalVisible: false,
      carIcon,
    };
  },
  methods: {
    ...mapActions({
      searchByVin: 'level4/searchByVin',
      resetVehicleFilters: 'level4/resetVehicleFilters',
    }),
    onReset() {
      this.resetVehicleFilters();
      this.searchByVin(false);
      this.$router.push('/level4');
    },
  },
  computed: {
    isBarVisible() {
      return this.vehicleData?.Vin || this.vehicleData?.VehicleInfo?.foundByFilters;
    },
    hasCampaigns() {
      const { TechnicalCampaigns = [] } = this.vehicleData;
      return TechnicalCampaigns.length;
    },
    ...mapGetters({
      vehicleData: 'level4/vehicleData',
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers";
@import "src/scss/_breakpoint";

.button-mod {
  text-transform: uppercase;
  color: var(--c-primary);
}

.container-fluid {
  padding: 1rem;
  text-align: center;
}

.font-wrapper {
  display: inline;
  font-size: 17px;
}

.info-icon {
  position: relative;
  display: inline-block;
  top: 3px;
  margin-right: 5px;
}

.car-icon {
  position: relative;
  display: inline-block;
  top: 3px;
  width: 16px;
}

a {
  font-size: var(--font-sm);
  font-family: var(--font-family-secondary);
  font-weight: var(--font-medium);
  color: var(--c-text);
  &:hover {
    color: var(--_c-blue-primary);
  }
}
</style>
